//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiProgress from "../../components/cancel_plan/Progress";
import { mapGetters } from "vuex";
import { sendFeedback } from "../../services/payment";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/error";
export default {
  name: "CancelFeedbackPage",
  components: { HiHeader, HiProgress },
  data() {
    return {
      showMsg: false,
      feedback: "",
    };
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    unsubscription() {
      return this.user.unsubscription;
    },
    banner() {
      // 如果存在优惠则显示offer，不存在则直接显示detail
      const list = [
        { text: "Feedback", active: true },
        { text: "Detail", active: false },
      ];
      if (this.unsubscription) {
        list.push({ text: "Offer", active: false });
      }
      return list;
    },
  },
  methods: {
    async closeClick() {
      if (!this.feedback) {
        this.$router.go(-1);
        return;
      }
      try {
        this.$loading.show();
        await sendFeedback({ feedback: this.feedback });
        this.feedback = "";
        this.$router.go(-1);
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    nextClick() {
      // 验证feedback是否已经输入
      if (this.feedback) {
        this.showMsg = false;
        this.$router.push({
          name: "CancelDetailPage",
          query: { feedback: this.feedback },
        });
      } else {
        this.showMsg = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/cancel_plan/Feedback.vue